import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StyledTrustPilot, Header } from './styles.js';
import { TrustPilotCarousel } from './TrustPilotCarousel';
import { loadTrustPilot } from './trustpilot';

export const TrustPilot = ({ header }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    loadTrustPilot(() => {
      setLoaded(true);
    });
  });

  return (
    <StyledTrustPilot>
      <Header>{header}</Header>
      {loaded && <TrustPilotCarousel />}
    </StyledTrustPilot>
  );
};

TrustPilot.displayName = 'TrustPilot';

TrustPilot.propTypes = {
  header: PropTypes.string.isRequired,
};
